<script setup lang="ts">
import type { FormCva } from '@autobid/ui/utils/cva/formCva'
import { formCva } from '@autobid/ui/utils/cva/formCva'

interface Props {
  alignment?: FormCva['alignment']
  width: FormCva['width']
  title?: string
}

defineProps<Props>()
</script>

<template>
  <section
    class="flex h-full w-full items-center px-3 py-8 xl:pl-0"
    :class="
      formCva({
        alignment,
      })
    "
  >
    <div
      :class="
        formCva({
          width,
        })
      "
    >
      <header v-if="title" class="w-full break-all text-6xl">
        {{ title }}
      </header>
      <slot />
    </div>
  </section>
</template>
